import { Component } from "../core/Component";
import GameConfig from "../core/data/GameConfig";
import { PlanckBodyComponent } from "./PlanckBodyComponent";
import { Player } from "./Player";
import { PlayerStateTypes } from "./PlayerStates/PlayerState";

export class SkatesEffect extends Component {

	obj: Player;
	body: PlanckBodyComponent;
	timer = 2;
	accel: number;
	maxVX: number;
	boostY: number;

	allowSlam = false;

	constructor(obj: Player) {
		super(obj);
		this.body = this.obj.planckBody;
		this.timer = GameConfig.get<number>("skatesDuration");
		this.accel = GameConfig.get<number>("skatesAccelX");
		this.maxVX = GameConfig.get<number>("skatesMaxVX")* this.obj.detonatorMultiplier;
		this.boostY = GameConfig.get<number>("skatesExplosionBoostY") * this.obj.detonatorMultiplier;
		this.obj.emit(PlayerStateTypes.RollerSkates);

	}

	public update(dt: number): void {
		if (this.body.velocity.x < this.maxVX) this.body.velocity.x += this.accel * dt;
		this.timer -= dt;
		if (this.timer <= 0) {
			this.destroyEffect();
		}
	}

	public destroyEffect(): void{
		this.obj.endEffect();
		this.body.velocity.y = Math.min(this.boostY, this.body.velocity.y);
		this.obj.evalFlight();
		this.destroy();
	}


}